import {
  Apps,
  Book,
  Business,
  GetApp,
  Help,
  Home,
  Info,
  Person,
  Stars,
} from '@mui/icons-material';
import { useEffect, useState } from 'react';

const WAYA_SECTIONS = [
  { id: 'hero', label: 'Home', icon: <Home fontSize="small" /> },
  { id: 'about', label: 'About', icon: <Info fontSize="small" /> },
  { id: 'services', label: 'Services', icon: <Apps fontSize="small" /> },
  { id: 'personal', label: 'Personal', icon: <Person fontSize="small" /> },
  { id: 'business', label: 'Business', icon: <Business fontSize="small" /> },
  { id: 'competitive', label: 'Compare', icon: <Stars fontSize="small" /> },
  { id: 'solution', label: 'Steps', icon: <Info fontSize="small" /> },
  { id: 'testimonials', label: 'Reviews', icon: <Stars fontSize="small" /> },
  { id: 'refer', label: 'Refer', icon: <Stars fontSize="small" /> },
  { id: 'ecosystem', label: 'Ecosystem', icon: <Info fontSize="small" /> },
  { id: 'faq', label: 'FAQ', icon: <Help fontSize="small" /> },
  { id: 'download', label: 'Get App', icon: <GetApp fontSize="small" /> },
];

export default function FloatingSectionNav() {
  const [active, setActive] = useState('hero');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrollPos = window.scrollY;
      const windowHeight = window.innerHeight;
      const bodyHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;

      // Show when past hero section and not at the very bottom (footer)
      const isPastHero = scrollPos > 400;
      const isBeforeFooter = scrollPos + windowHeight < bodyHeight - 100;

      setVisible(isPastHero && isBeforeFooter);
    };

    window.addEventListener('scroll', onScroll);
    onScroll();

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const observers = WAYA_SECTIONS.map(({ id }) => {
      const el = document.getElementById(id);
      if (!el) return null;
      const obs = new IntersectionObserver(
        ([e]) => {
          if (e.isIntersecting) setActive(id);
        },
        { threshold: 0.35, rootMargin: '-80px 0px 0px 0px' }
      );
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach((o) => o?.disconnect());
  }, []);

  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  if (!visible || active === 'solution') return null;

  return (
    <div className="waya-floating-nav-container">
      {WAYA_SECTIONS.map(({ id, label, icon }) => (
        <button
          key={id}
          onClick={() => scrollTo(id)}
          className={`waya-nav-pill ${active === id ? 'active' : ''}`}
          title={label}
        >
          <span className="nav-icon">{icon}</span>
          <span className="nav-label">{label}</span>
        </button>
      ))}
    </div>
  );
}
